import { ImageLoaderCSSStyleImpl } from '../../../../../toolkit/imageloader/imageloadercss';

export class MyTonesEvenCardImageLoaderCSSStyleImpl extends ImageLoaderCSSStyleImpl {
    getImgCSSStyle(): object {
        return {
            objectFit: 'cover',
            width: '100%',
            height: '250px',
            borderRadius: "0px 50px",
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/listtone/viewmodel/mytonescard/mytonesevencardimageloader.tsx